export const SITE_URL = 'https://www.qbp.solutions';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/logos/logo-marque-noir.webp`;

const FR_TO_EN: Record<string, string> = {
  '/mentions-legales': '/en/legal-notice',
  '/catalogue': '/en/catalog',
  '/solutions/conformite': '/en/solutions/compliance',
  '/reprise-parc-informatique': '/en/it-fleet-buyback',
};

const EN_TO_FR: Record<string, string> = {
  '/en/legal-notice': '/mentions-legales',
  '/en/catalog': '/catalogue',
  '/en/solutions/compliance': '/solutions/conformite',
  '/en/it-fleet-buyback': '/reprise-parc-informatique',
};

export function toEnPath(frPath: string): string {
  if (FR_TO_EN[frPath]) return FR_TO_EN[frPath];
  if (frPath === '/') return '/en';
  return `/en${frPath}`;
}

export function toFrPath(enPath: string): string {
  if (EN_TO_FR[enPath]) return EN_TO_FR[enPath];
  if (enPath === '/en') return '/';
  return enPath.replace(/^\/en/, '') || '/';
}

export type Lang = 'fr' | 'en';

export interface LocalizedPaths {
  fr: string;
  en: string;
}

export function getLocalizedPaths(currentPath: string, currentLang: Lang): LocalizedPaths {
  if (currentLang === 'fr') {
    return { fr: currentPath, en: toEnPath(currentPath) };
  }
  return { fr: toFrPath(currentPath), en: currentPath };
}

export function absoluteUrl(path: string): string {
  return `${SITE_URL}${path}`;
}
